import React from "react";
import { FixedObject } from "gatsby-image";
import { Helmet } from "react-helmet";
import {
  languageCodeFromLocale,
  Locale,
} from "../../../config/sites-and-locales";
import { getOpenGraphTags } from "./SEO/open-graph-tags";
import { getTwitterTags } from "./SEO/twitter-tags";
import { getHTMLTags } from "./SEO/html-tags";
import { ServiceStructuredData } from "./ServiceStructuredData";

interface SEOProps {
  canonicalUrl: string;
  hreflangData?: any; // TODO: Make this type declaration work (very frustrating)
  locale: Locale;
  metaTitle?: any;
  noIndexMeta: boolean;
  pageDescription: string;
  pageImage?: FixedObject;
  pageTitle: string;
  serviceType?: string;
}

export function SEO({
  canonicalUrl,
  hreflangData,
  locale,
  metaTitle,
  noIndexMeta,
  pageDescription,
  pageImage,
  pageTitle,
  serviceType,
}: SEOProps) {
  /*
    This component manages shared behavior between locations pages and services pages.
    metaTitle only exists for location service pages, hence the reason for this check.
  */
  const title = canonicalUrl.includes("/locations/") ? metaTitle : pageTitle;

  const openGraphTags = getOpenGraphTags({
    canonicalUrl,
    pageDescription,
    title,
    pageImage,
    locale,
  });
  const twitterTags = getTwitterTags();
  const htmlTags = getHTMLTags({ noIndexMeta, pageDescription, title });
  const meta = [...openGraphTags, ...twitterTags, ...htmlTags];
  const lang = languageCodeFromLocale(locale);
  const prefix = "og: http://ogp.me/ns# fb: http://ogp.me/ns/fb#";
  const htmlAttributes = { lang, prefix };

  const hreflangLinks = hreflangData?.map((hreflang: any) => ({
    href: hreflang.url,
    hreflang: hreflang.locale,
    rel: "alternate",
  }));

  const link = [{ rel: "canonical", href: canonicalUrl }].concat(
    hreflangLinks || []
  );

  return (
    <>
      <Helmet
        htmlAttributes={htmlAttributes}
        link={link}
        meta={meta}
        title={title}
      />
      {serviceType ? (
        <ServiceStructuredData
          serviceType={serviceType}
          description={pageDescription}
        />
      ) : null}
    </>
  );
}
